import { Box, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const ReportBox = styled(Box)(({ theme }) => ({
  flex: 1,
  background: "white",
  borderRadius: theme.borders.borderRadius.xxl_16,
  maxHeight: "calc(100vh - 116px)",
  overflowY: "auto",
  paddingBottom: pxToRem(24),
}));

export const Header = styled(Box)(({ theme }) => ({
  position: "relative",
  background: theme.palette.colorsBase.blue_0,
  borderRadius: theme.borders.borderRadius.xl_12,
  padding: pxToRem(28),
  paddingTop: pxToRem(40),
  margin: pxToRem(12),
}));

export const TitleReport = styled("div")(({ theme }) => ({
  width: "100%",
  color: "white",

  fontSize: `${theme.typography.size.xxl_24}`,
  fontWeight: theme.typography.fw_semibold_600,
  lineHeight: theme.typography.lineHeight.lg,
}));
export const CreateDay = styled("div")(({ theme }) => ({
  color: "white",
  fontSize: `${theme.typography.size.sm_14}`,
  lineHeight: theme.typography.lineHeight.sm,
  flex: 1,
}));

export const BackgroundItemWrap = styled("div")(({ theme }) => ({
  position: "absolute",
  right: theme.functions.pxToRem(70),
  bottom: -5,
}));

export const Content = styled("div")(({ theme }) => ({
  padding: `${pxToRem(12)} ${pxToRem(28)}`,
  marginBottom: pxToRem(8),
  "& ul": {
    listStyleType: "none",
  },
  "& li": {
    marginBottom: pxToRem(20),
  },
}));

export const Footer = styled("div")(({ theme }) => ({
  position: "absolute",
  width: pxToRem(364),
  bottom: 0,
  background: "white",
  height: pxToRem(56),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  left: 0,
  borderTop: `1px solid ${theme.palette.stroke.strokeDefault2}`,

  borderBottomLeftRadius: theme.borders.borderRadius.xxl_16,
  borderBottomRightRadius: theme.borders.borderRadius.xxl_16,
}));

export const Detail = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: pxToRem(32),
  maxWidth: 'calc(100vw - 620px)',
  flex: 1,
  '@media (max-width: 1440px)': {
    maxWidth: 'calc(100vw - 450px)'
  },
  '@media (max-width: 1024px)': {
    maxWidth: 'calc(100vw - 100px)'
  },
}));

export const BackWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: pxToRem(8),
  marginRight: pxToRem(48),
  cursor: "pointer",
  position: "fixed",
  '@media (max-width: 1440px)': {
    "& p": {
      display: 'none'
    }
  },
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
}));

export const OtherReportWrapper = styled(Box)(({ theme }) => ({
  width: pxToRem(364),
  position: "relative",
  background: "white",
  borderRadius: theme.borders.borderRadius.xxl_16,
}));

export const OtherReportTitle = styled(Box)(({ theme }) => ({
  paddingTop: pxToRem(20),
  paddingBottom: pxToRem(20),
  paddingLeft: pxToRem(28),
  paddingRight: pxToRem(24),
  fontSize: `${theme.typography.size.xl_20}`,
}));

export const ListOtherReport = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100vh - 260px)",
  height: "calc(100vh - 260px)",
  gap: pxToRem(24),
  paddingLeft: `${pxToRem(28)}`,
  paddingRight: `${pxToRem(24)}`,
  marginRight: pxToRem(3),
  marginBottom: pxToRem(60),
}));

export const DetailReportWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexGrow: 1,
  padding: pxToRem(32),
  paddingRight: pxToRem(164),
  gap: pxToRem(32),
  '@media (max-width: 1440px)': {
    paddingRight: pxToRem(10),
    "& .back": {
      width: pxToRem(25)
    }
  },
}));
